import { Injectable } from '@angular/core';

const SC_PUBLIC_PEM_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8zxixWN236eXKN66HK9x1T8W6
Gx7s5tkJ0HXwr0aMoLHRkolcmgwu3myyLT5ASYFnv/Bxxoq1Vgt8OFmp0tiMV5P1
iaFyrzLYtUFsKY2GU6owFELTosbbOc0J+DyN9NIf/atuNApBeDfXZXm97LXYZPi7
Eta7y4IlrKD0aWesuwIDAQAB
-----END PUBLIC KEY-----`;

@Injectable({
  providedIn: 'root'
})
export class AgricolaPaymentCryptoService {
  async encrypt(text: string): Promise<string> {
    const subtle = globalThis.crypto?.subtle;
    if (!subtle) {
      throw new Error('RSA-OAEP encryption is not available in this browser.');
    }

    const publicKey = await subtle.importKey(
      'spki',
      this.pemToArrayBuffer(SC_PUBLIC_PEM_KEY),
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256'
      },
      false,
      ['encrypt']
    );
    const encrypted = await subtle.encrypt(
      { name: 'RSA-OAEP' },
      publicKey,
      new TextEncoder().encode(text)
    );

    return this.arrayBufferToBase64(encrypted);
  }

  private pemToArrayBuffer(pem: string): ArrayBuffer {
    const base64 = pem
      .replace(/-----BEGIN PUBLIC KEY-----/g, '')
      .replace(/-----END PUBLIC KEY-----/g, '')
      .replace(/\s/g, '');
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return bytes.buffer;
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';

    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  }
}
